<template>
  <div ref="page" class="diagnosis">
    <legend-diagnosis></legend-diagnosis>
    <base-form
      ref="form"
      class="search-bar"
      v-model="toolbar.data"
      :form-items="toolbar.formItems"
      label-width="auto"
      input-trim
      inline
    ></base-form>
    <base-table-lite
      ref="table"
      url="view/getDiagData"
      :columns="columns"
      :init-search="false"
      @loaded="tableLoaded"
    ></base-table-lite>
    <diag-extra-view
      v-model="extraView.visible"
      :packid="extraView.packid"
      :version="extraView.version"
      :lang="currentLang"
      :sub_field="extraView.sub_field"
      :nos="extraView.nos"
      :label="extraView.label"
      :searchText="extraView.searchText"
    ></diag-extra-view>
  </div>
</template>

<script>
export default {
  name: 'diagnosis',
  data() {
    var currentLang = this.$root.getCurrentLang()
    return {
      //默认主功能表查询字段
      defaultSearchField: [
        'year',
        'series',
        'displacement',
        'engine_type',
        'chassis',
        'part',
        'area',
        'model',
        'system',
        'system_type'
      ],
      profile: '',
      searchFieldFormItems: [],
      //默认额外功能表查询字段
      defaultExtraSearchField: ['actuation_test', 'special_functions'],
      extraSearchFields: [],
      currentFields: [],
      currentLang,
      currentLangLowerCase: currentLang.toLowerCase(),
      currentProduct: null,
      //currentBrand: '',
      extraView: {
        visible: false,
        packid: '',
        version: '',
        lang: currentLang,
        sub_field: '',
        nos: '',
        label: ''
      },
      toolbar: {
        formItems: [
          {
            label: currentLang == 'CN' ? '产品' : 'Product',
            prop: 'product',
            component: 'product-select',
            bind: {
              lang: currentLang,
              category: 'diag',
              profile: this.$route.query.configName
            },
            on: {
              productChange: (product) => {
                this.currentProduct = product
                this.profile=product.profile
                this.toolbar.query.profile=product.profile
                this.$nextTick(() => {
                  this.toolbar.formItems[1].bind.profile = product.profile
                })
              }
            }
          },
          {
            label: currentLang == 'CN' ? '品牌' : 'Brand',
            prop: 'pack_brand',
            component: 'brand-select',
            bind: {
              lang: currentLang,
              category: 'diag',
              profile: '',
              packid: this.$route.query.packId,
              version: this.$route.query.packVer
            },
            on: {
              outVersion: (option, versions) => {
                const { profile, brand, packid, version } = option
                const queryObj = { profile, brand, packid, version }
                this.toolbar.query.packid = option.packid
                this.toolbar.query.brand = JSON.stringify({
                  Field: 'brand',
                  ComparePattern: 'EQ',
                  Values: [option.brand]
                })
                this.$nextTick(() => {
                  const formItemVersion = this.toolbar.formItems[2]
                  formItemVersion.bind.queryObj = queryObj
                  formItemVersion.bind.version = versions
                })
              }
            }
          },
          {
            label: currentLang == 'CN' ? '版本' : 'Version',
            prop: 'version',
            component: 'version-select',
            bind: { version: [] },
            on: {
              change: (newVal) => {
                this.$nextTick(() => {
                  this.getDiagField()
                })
              }
            }
          }
        ],
        data: {},
        query: {
          packid: null,
          brand: ''
        }
      },
      columns: []
    }
  },
  created() {
    this.$root.autoSetCurrentLang()
  },
  computed: {
    table() {
      return this.$refs.table
    },
    form() {
      return this.$refs.form
    }
  },
  methods: {
    assertField(field) {
      //这些列不显示
      if (['brand', 'version','maintenance'].indexOf(field) > -1) {
        return false
      }
      if (this.currentProduct) {
        switch (field) {
          case 'programming':
            return this.currentProduct.programming
          case 'coding':
            return this.currentProduct.coding
          case 'special_functions':
            return this.currentProduct.special_functions
          case 'actuation_test':
            return this.currentProduct.actuation_test
          case 'component_protection':
          case 'parameterized':
            return this.currentProduct.online_functions
          case 'boot_functions':
            return this.currentProduct.boot_functions
        }
      }
      return true
    },
    getDiagField() {
      var searchData = this.toolbar.data
      //console.log(searchData)
      this.$post('view/getDiagField', {
        packid: this.toolbar.query.packid,
        version: searchData.version,
        lang: this.currentLang,
        profile: this.profile
      })
        .then((resp) => {
          if (resp.data.code == 0) {
            var columns = []
            this.searchFieldFormItems = []
            this.extraSearchFields = []
            var currentFields = []
            this.initToolbarFormItems()
            var fieldIndex = 0
            for (var item of resp.data.data) {
              //过滤不显示的列
              if (!this.assertField(item.field)) {
                continue
              }
              var column = {
                bind: {
                  label: item[this.currentLang.toLowerCase()],
                  prop: item.field
                }
              }
              //用对应组件渲染显示数据类型
              if (item.data_type) {
                column.default = {
                  component: item.data_type.replace('|', ''),
                  bind: { lang: this.currentLang },
                  on: { view: this.viewExtra }
                }
              }
              columns.push(column)

              //查找动态查询条件框
              if (this.defaultSearchField.indexOf(item.field) > -1) {
                currentFields.push(item.field)
                this.searchFieldFormItems.push({
                  label: item[this.currentLang.toLowerCase()],
                  prop: item.field,
                  component: 'field-select',
                  bind: {
                    fieldIndex: fieldIndex,
                    category: 'diag',
                    field: item.field,
                    lang: this.currentLang,
                    packid: this.toolbar.query.packid,
                    version: searchData.version
                    //brand: this.currentBrand,
                  },
                  on: {
                    valchange: (index, val) => {
                      this.resetSearchFieldBeginBy(index, val)
                      this.tableSearch()
                    }
                  }
                })
                fieldIndex++
              }

              //查找额外功能表动态查询条件框
              if (this.defaultExtraSearchField.indexOf(item.field) > -1) {
                this.extraSearchFields.push({
                  field: item.field,
                  label: item[this.currentLang.toLowerCase()]
                })
              }
            }
            this.currentFields = currentFields
            this.columns = columns
            this.$nextTick(() => {
              for (var item of this.searchFieldFormItems) {
                this.toolbar.formItems.push(item)
              }
              if (this.extraSearchFields.length > 0) {
                this.toolbar.formItems.push({
                  label:
                    this.currentLang.toLowerCase() == 'cn'
                      ? '功能'
                      : 'Function',
                  prop: 'extra',
                  component: 'extra-search',
                  bind: {
                    style: {
                      width: '215px'
                    },
                    //category: 'diag',
                    //fields: this.extraSearchFields,
                    lang: this.currentLang,
                    placeholder: this.extraSearchFields
                      .map((item) => item.label)
                      .join(' / ')
                  },
                  on: {
                    search: (val) => {
                      if (this.checkExtraCondition()) {
                        this.tableSearch()
                      }
                    }
                  }
                })
              }
              //第一个动态查询条件框价值初始化option
              this.firstSearchFieldInit()
              this.tableSearch()
            })
          } else {
            this.$message(resp.data.msg || '获取数据失败')
          }
        })
        .catch((error) => {
          console.error(error)
          this.$message('请求发生错误=>' + error)
        })
    },
    checkExtraCondition() {
      // for (var item of this.$refs.form.items) {
      //   console.log(item)
      //   if (item.name == 'field-select') {
      //     if (item.options.length > 0 && !item.val) {
      //       alert(
      //         (this.currentLang.toLowerCase() == 'cn'
      //           ? '请选择 '
      //           : 'Please select ') + item.label
      //       )
      //       return false
      //     }
      //   }
      // }
      //console.log(this.$refs.form.items)

      for (var item of this.searchFieldFormItems) {
        if (
          item.prop.indexOf('system') < 0 &&
          item.prop.indexOf('part') < 0 &&
          item.$this.options.length > 0
        ) {
          if (!item.$this.val) {
            alert(
              (this.currentLang.toLowerCase() == 'cn'
                ? '请选择 '
                : 'Please select ') + item.label
            )
            return false
          }
        }
      }
      return true
    },
    initToolbarFormItems() {
      if (this.toolbar.formItems.length > 3) {
        //找出多余的prop
        var props = []
        for (var i = 3; i < this.toolbar.formItems.length; i++) {
          props.push(this.toolbar.formItems[i].prop)
        }
        this.toolbar.formItems.splice(3)
        //删除多余的prop
        for (var prop of props) {
          this.$delete(this.toolbar.data, prop)
        }
      }
    },
    getSearchData() {
      var searchData = Object.assign({}, this.toolbar.data, this.toolbar.query)
      for (var field of this.defaultSearchField) {
        if (searchData[field]) {
          searchData[field] = JSON.stringify({
            Field: field,
            ComparePattern: 'EQ',
            Values: [searchData[field]]
          })
        }
      }
      if (this.extraSearchFields.length > 0) {
        searchData.extraFields = this.extraSearchFields
          .map((item) => item.field)
          .join(',')
      }
      return searchData
    },
    tableSearch() {
      this.table.table.doLayout()
      this.$nextTick(() => {
        this.table.searchData = this.getSearchData()
        this.table.searchData.lang = this.currentLang
        // this.$eventBus.$emit(
        //   'searchDataChange',
        //   this.table.searchData,
        //   this.currentFields
        // )
        this.table.query.PageIndex = 1
        this.table.refreshData()
      })
    },
    viewExtra(scope) {
      var searchData = this.table.searchData
      if (this.defaultExtraSearchField.indexOf(scope.column.property) > -1) {
        this.extraView.searchText = searchData.extra
      } else {
        this.extraView.searchText = ''
      }
      this.extraView.packid = this.toolbar.query.packid
      this.extraView.version = searchData.version
      this.extraView.lang = searchData.lang
      // console.log(scope.column)
      this.extraView.sub_field = scope.column.property
      this.extraView.label = scope.column.label
      this.extraView.visible = true

      this.extraView.nos = this.$getPropValue(scope.row, scope.column.property)
    },
    tableLoaded() {
      window.parent.postMessage(
        {
          callback: 'setIframeHeight',
          args: [this.$refs.page.scrollHeight + 50]
        },
        '*'
      )
    },
    firstSearchFieldInit() {
      this.$nextTick(() => {
        var searchData = this.getSearchData()
        for (var item of this.$refs.form.items) {
          if (item.fieldIndex == 0) {
            item.getFieldOptions(searchData)
            break
          }
        }
      })
    },
    resetSearchFieldBeginBy(index, val) {
      var searchData = this.getSearchData()
      for (var item of this.$refs.form.items) {
        if (item.fieldIndex > index) {
          item.reset()
          if (val && item.fieldIndex == index + 1) {
            item.getFieldOptions(searchData)
          }
        }
      }
      //重置extra-search (extra-search为最后一个)
      this.$refs.form.items[this.$refs.form.items.length - 1].reset()
    }
  }
}
</script>
<style lang="less">
.diagnosis {
}
</style>
